import { Injectable } from "@angular/core";
import { doc, Firestore, getDoc, serverTimestamp, setDoc } from "@angular/fire/firestore";
import { UserService } from "./user.service";

@Injectable({
    providedIn: 'root'
})
export class ChatConfigurationService {
    constructor(
        private fs: Firestore,
        private userService: UserService,
    ) { }

    async saveUserDataMessage(message: string, version: string = "2.0"): Promise<void> {
        const userId = this.userService.user.id;
        const ref = doc(this.fs, `v0/data/user/${userId}/bellaChat/userDataMessage`); // document path (6 segments)
        await setDoc(ref, {
            message,
            source: 'user',
            chatVersion: version,
            createdAt: serverTimestamp(),
        }, { merge: true });
    }

    async readUserDataMessage(): Promise<{message: string, source: string, chatVersion: string, createdAt: Date} | null> {
        const userId = this.userService.user?.id;
        if (!userId) throw new Error('Missing user id');


        const ref = doc(this.fs, 'v0', 'data', 'user', userId, 'bellaChat', 'userDataMessage');
        const snap = await getDoc(ref);

        if (!snap.exists()) return null;

        const data = snap.data() as any;
        return {
            message: data?.message ?? '',
            source: data?.source ?? 'user',
            chatVersion: data?.chatVersion ?? '2.0',
            createdAt: data?.createdAt?.toDate?.() ?? new Date()
        };
    }
}